import React, { useEffect, useState } from 'react'
import { fetchHealthData } from '../../api/healthDataApi';
import { fetchArticles } from '../../api/educationalContentApi';
import { filterEducationalContent } from '../../utils/filterEducationalContent';
import { getMedicalConditions } from '../../api/medicalConditionApi';
import { getSurgeries } from '../../api/surgeryApi';

export default function Articles({ userId }) {
    const [filteredArticles, setFilteredArticles] = useState([]);
    const [userConditions, setUserConditions] = useState(null);

    useEffect(() => {
        const fetchUserConditions = async () => {
            try {
                const medicalConditions = await getMedicalConditions(userId);
                const surgeries = await getSurgeries(userId);
                const allConditions = [
                    ...medicalConditions.map(c => c.condition_name.toLowerCase()),
                    ...surgeries.map(s => s.surgery_name.toLowerCase())
                ];

                setUserConditions(allConditions);
            } catch (error) {
                console.error("Error fetching health data:", error);
            }
        };

        fetchUserConditions();
    }, [userId]);

    useEffect(() => {
        if (userConditions === null) return;

        const fetchUserArticles = async () => {
            try {
                const data = await fetchArticles();

                const filtered = filterEducationalContent(data, userConditions);
                setFilteredArticles(filtered);
            } catch (error) {
                console.error("Error fetching articles:", error);
            }
        }

        fetchUserArticles();
    }, [userConditions])

    if (userConditions === null) return <div>Loading user data...</div>;
    if (!filteredArticles.length) return <div className="mb-2">No articles available.</div>;

    return (
        <section>
            <div className="mb-8">
                <div className="flex gap-4 overflow-x-auto">
                    {filteredArticles.map((article, index) => (
                        <a
                            key={index}
                            href={article.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="min-w-[250px] p-4 bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow"
                        >
                            <h4 className="font-bold text-[#04395b] mb-2">
                                {getSourceName(article.url)}
                            </h4>
                            <p className="text-sm text-gray-600">{article.title}</p>
                        </a>
                    ))}
                </div>
            </div>
        </section>

    )
}

function getSourceName(url) {
    try {
        const domain = new URL(url).hostname;
        if (domain.includes("mayoclinic")) return "Mayo Clinic";
        if (domain.includes("webmd")) return "WebMD";
        if (domain.includes("cdc")) return "CDC";
        if (domain.includes("hss")) return "HSS";
        return domain.replace("www.", "");
    } catch {
        return "Source";
    }
}
